/**
 * Check if a date is overdue (earlier than today)
 * @param dateString - Date string in ISO format or any Date-parsable string
 * @returns boolean - true if date is earlier than today (ignoring time)
 */
export function isDateOverdue(dateString: string | Date | null | undefined): boolean {
  if (!dateString) return false

  try {
    const dueDate = new Date(dateString)
    const today = new Date()

    // Reset both dates to midnight for accurate date-only comparison
    const dueDateOnly = new Date(dueDate.getFullYear(), dueDate.getMonth(), dueDate.getDate())
    const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate())

    return dueDateOnly < todayOnly
  } catch (error) {
    console.error('Error parsing date:', error)
    return false
  }
}
